<template>
  <div class="chat">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <left-sidebar></left-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper" style="min-height: 657px;
      left: 0;
      padding-top: 60px;">
        <!-- Chat Main Row -->
        <div class="chat-main-row">
          <LightBox
            :ref="'lightbox'"
            :showLightBox="false"
            v-if="groupMessageMedia.length>0"
            :media="groupMessageMedia"
          ></LightBox>
          <!-- Chat Main Wrapper -->
          <div class="chat-main-wrapper">
            <div class="col-lg-9 message-view task-view">
              <div class="chat-window">
                <div class="fixed-header" v-if="activeRoomId!=''">
                  <div class="navbar">
                    <div class="user-details mr-auto">
                      <div class="float-left user-img">
                        <!-- <router-link to="/profile" class="avatar" title="{{avatarArr.room_title}}"> -->
                        <router-link to="#" class="avatar" :title="avatarArr.room_title">
                          <img
                            src="@/assets/profiles/avatar-02.jpg"
                            alt
                            class="rounded-circle"
                            v-if="avatarArr.room_photo==''"
                          />
                          <img v-lazy="avatarArr.room_photo" alt class="rounded-circle" v-else />
                          <span class="status online"></span>
                        </router-link>
                      </div>
                      <div class="user-info float-left">
                        <!-- <router-link to="/profile" title="{{avatarArr.room_title}}"> -->
                        <router-link to="#" :title="avatarArr.room_title">
                          <span>{{avatarArr.room_title}}</span>
                          <!-- <i class="typing-text">Typing...</i> -->
                        </router-link>
                        <!-- <span class="last-seen">Last seen today at 7:50 AM</span> -->
                      </div>
                    </div>
                    <div class="search-box">
                      <div class="input-group input-group-sm">
                        <input
                          type="text"
                          placeholder="Search"
                          v-model="keywords"
                          @change="searchHandler"
                          class="form-control"
                        />
                        <span class="input-group-append">
                          <button @click="searchHandler" type="button" class="btn">
                            <i class="fa fa-search"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                    <ul class="nav custom-menu">
                      <li class="nav-item">
                        <a
                          class="nav-link task-chat profile-rightbar float-right"
                          id="task_chat"
                          href="#task_window"
                        >
                          <i class="fa fa-user"></i>
                        </a>
                      </li>
                      <li class="nav-item dropdown dropdown-action">
                        <div class="dropdown action-label">
                          <a
                            aria-expanded="false"
                            data-toggle="dropdown"
                            class="nav-link dropdown-toggle"
                            href="#"
                            v-if="isNotResolveData==true"
                          >
                            <i class="fa fa-dot-circle-o text-info"></i>
                            Open
                          </a>
                          <div
                            class="dropdown-menu dropdown-menu-right"
                            v-if="isNotResolveData==true"
                          >
                            <a class="dropdown-item" @click.prevent="setResolve" href="#">
                              <i class="fa fa-dot-circle-o text-success"></i> Resolved
                            </a>
                          </div>
                          <span
                            aria-expanded="false"
                            data-toggle="dropdown"
                            class="nav-link dropdown-toggle"
                            v-else
                          >
                            <i class="fa fa-dot-circle-o text-success"></i>
                            Resolved
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="chat-contents">
                  <div class="chat-content-wrap" v-if="activeRoomId!=''">
                    <div class="chat-wrap-inner">
                      <infinite-loading
                        v-if="!loadingMessage"
                        spinner="spiral"
                        @infinite="infiniteHandler"
                      >
                        <div slot="spinner">Loading...</div>
                        <!-- <div slot="no-more">No more messages</div> -->
                        <div slot="no-more">
                          <span
                            v-if="(this.hotChatParam.totalRecords>0 && this.hotChatParam.rendered>=this.hotChatParam.totalRecords)"
                          >No more messages</span>
                          <span v-if="(this.hotChatParam.totalRecords==0)">No more messages</span>
                          <span
                            v-if="(this.hotChatParam.totalRecords>0 && this.hotChatParam.rendered==0)"
                          >No more messages</span>
                        </div>
                        <div slot="no-results">
                          <span v-if="(this.hotChatParam.totalRecords==0)">No results message</span>
                          <span v-else>No more messages</span>
                        </div>
                      </infinite-loading>

                      <div class="chat-box">
                        <div class="chats" v-if="loadingMessage">
                          <Skeleton :count="3" />
                        </div>
                        <div class="chats" :style=" 'background: url(\''+whatsappBackground+'\');'">
                          <div v-for="(rowArr,date) in groupChatByDate" :key="date">
                            <div class="chat-line" :id="'chat-'+date">
                              <span class="chat-date">{{date}}</span>
                            </div>
                            <div v-for="row in rowArr" :key="row.id">
                              <div class="chat chat-right" v-if="row.from_me==1">
                                <div class="chat-body">
                                  <div class="chat-bubble" v-if="row.message_type=='document'">
                                    <div class="chat-contents">
                                      <div
                                        class="chat-file-desc"
                                        v-if="typeof row.quoted_message != 'undefined'"
                                      >
                                        <div class="experience-box">
                                          <ul class="experience-list">
                                            <li>
                                              <div class="experience-user">
                                                <div class="before-circle"></div>
                                              </div>
                                              <div
                                                class="experience-content"
                                                style="margin-left:20px;"
                                              >
                                                <div
                                                  style="margin-right:5px;margin-left:5px;"
                                                  class="timeline-content"
                                                >
                                                  <small class="text-info">
                                                    <i>
                                                      <b
                                                        v-if="row.quoted_message.from_me == 0"
                                                      >{{ row.quoted_message.message_name}}</b>
                                                      <b v-else>You</b>
                                                    </i>
                                                  </small>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'text'"
                                                  >{{row.quoted_message.message}}</p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'"
                                                  >
                                                    <i class="fa fa-file-image-o"></i> image
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'document'"
                                                  >
                                                    <i class="fa fa-file-o"></i> doc
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'video' "
                                                  >
                                                    <i class="fa fa-film"></i> video
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'file' "
                                                  >
                                                    <i class="fa fa-file-image-o"></i> file
                                                  </p>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <ul class="attach-list">
                                        <li>
                                          <i class="fa fa-file"></i>
                                          <a
                                            target="_blank"
                                            :href="row.message_media"
                                          >{{getExt(row.message_media)}}</a>
                                          <small>
                                            <br />
                                            {{row.message}} {{row.media_size}}
                                          </small>
                                        </li>
                                      </ul>
                                      <span class="chat-time">{{row.timeMinuteHour}}</span>
                                    </div>
                                  </div>
                                  <div class="chat-bubble" v-else-if="row.message_type=='image'">
                                    <div class="chat-content">
                                      <div
                                        class="chat-file-desc"
                                        v-if="typeof row.quoted_message != 'undefined'"
                                      >
                                        <div class="experience-box">
                                          <ul class="experience-list">
                                            <li>
                                              <div class="experience-user">
                                                <div class="before-circle"></div>
                                              </div>
                                              <div
                                                class="experience-content"
                                                style="margin-left:20px;"
                                              >
                                                <div
                                                  style="margin-right:5px;margin-left:5px;"
                                                  class="timeline-content"
                                                >
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'text'"
                                                  >{{row.quoted_message.message}}</p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'"
                                                  >
                                                    <i class="fa fa-file-image-o"></i> image
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'video' "
                                                  >
                                                    <i class="fa fa-film"></i> video
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'file' "
                                                  >
                                                    <i class="fa fa-file-image-o"></i> file
                                                  </p>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div class="chat-img-group clearfix">
                                        <a
                                          class="chat-img-attach"
                                          @click.prevent="openGallery(row.message_media)"
                                        >
                                          <img
                                            width="182"
                                            height="137"
                                            alt
                                            v-lazy="row.message_media"
                                          />
                                          <div class="chat-placeholder">
                                            <div class="chat-file-desc">{{row.media_size }}</div>
                                          </div>
                                        </a>

                                        <p
                                          v-html="messageFilter(row.message)"
                                          v-if="row.message!=''"
                                          v-linkified
                                        ></p>
                                        <span class="chat-time">
                                          {{row.timeMinuteHour}}
                                          <i
                                            title="pending message"
                                            class="text-info fa fa-clock-o"
                                            v-if="row.status == 1"
                                          ></i>
                                          <i
                                            title="error message"
                                            class="text-danger fa fa-warning"
                                            v-if="row.status == 0"
                                          ></i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="chat-bubble"
                                    v-else-if="row.message_type=='text' || row.message_type=='sticker' || row.message_type=='location'"
                                  >
                                    <div class="chat-content">
                                      <div
                                        class="chat-file-desc"
                                        v-if="typeof row.quoted_message != 'undefined'"
                                      >
                                        <div class="experience-box">
                                          <ul class="experience-list">
                                            <li>
                                              <div class="experience-user">
                                                <div class="before-circle"></div>
                                              </div>
                                              <div
                                                class="experience-content"
                                                style="margin-left:20px;"
                                              >
                                                <div
                                                  style="margin-right:5px;margin-left:5px;"
                                                  class="timeline-content"
                                                >
                                                  <small class="text-info">
                                                    <i>
                                                      <b
                                                        v-if="row.quoted_message.from_me == 0"
                                                      >{{ row.quoted_message.message_name}}</b>
                                                      <b v-else>You</b>
                                                    </i>
                                                  </small>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'text'"
                                                  >{{row.quoted_message.message}}</p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'"
                                                  >
                                                    <i class="fa fa-file-image-o"></i> image
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'video' "
                                                  >
                                                    <i class="fa fa-file-image-o"></i> video
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'file' "
                                                  >
                                                    <i class="fa fa-file-image-o"></i> file
                                                  </p>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <small
                                        class="text-info"
                                        v-if="row.from_me == 0 && row.is_group == 1"
                                      >
                                        <i>
                                          <b>{{ row.participant_name}}</b>
                                        </i>
                                      </small>
                                      <img
                                        style="max-width:50px;"
                                        v-lazy="row.message_media"
                                        v-if="row.message_type=='sticker'"
                                      />
                                      <p
                                        v-if="row.message_type=='text'"
                                        v-html="messageFilter(row.message)"
                                        v-linkified
                                      ></p>
                                      <p
                                        v-if="row.message_type=='location'"
                                        v-html="row.message"
                                        v-linkified
                                      ></p>
                                      <span class="chat-time">
                                        <i
                                          title="pending message"
                                          class="text-info fa fa-clock-o"
                                          v-if="row.status == 1"
                                        ></i>
                                        <i
                                          title="error message"
                                          class="text-danger fa fa-warning"
                                          v-if="row.status == 0"
                                        ></i>
                                        {{row.timeMinuteHour}}
                                      </span>
                                    </div>
                                    <div class="chat-action-btns">
                                      <ul v-if="row.status>=2">
                                        <li>
                                          <a
                                            @click="replyMessage(row.id)"
                                            href="javascript:void(0)"
                                            id="a-reply-msg"
                                            class="edit-msg"
                                          >
                                            <i :class="'fa fa-reply reply#' + row.id "></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div v-else class="chat-bubble">
                                    <div class="chat-content">
                                      <p class="text-muted">
                                        <i>Sorry, We do not support displaying {{row.message_type}} message at this time.</i>
                                      </p>
                                      <span class="chat-time">{{row.timeMinuteHour}}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="chat chat-left" v-if="row.from_me==0">
                                <div class="chat-avatar">
                                  <a href="javascript:void(0)" class="avatar">
                                    <img
                                      src="@/assets/profiles/avatar-02.jpg"
                                      alt
                                      v-if="avatarArr.room_photo==''"
                                    />
                                    <img v-lazy="avatarArr.room_photo" alt v-else />
                                  </a>
                                </div>
                                <div class="chat-body">
                                  <div
                                    class="chat-bubble"
                                    v-if="row.message_type=='document' || row.message_type=='video'"
                                  >
                                    <div class="chat-content">
                                      <div
                                        class="chat-file-desc"
                                        v-if="typeof row.quoted_message != 'undefined'"
                                      >
                                        <div class="experience-box">
                                          <ul class="experience-list">
                                            <li>
                                              <div class="experience-user">
                                                <div class="before-circle"></div>
                                              </div>
                                              <div
                                                class="experience-content"
                                                style="margin-left:20px;"
                                              >
                                                <div
                                                  style="margin-right:5px;margin-left:5px;"
                                                  class="timeline-content"
                                                >
                                                  <small class="text-info">
                                                    <i>
                                                      <b
                                                        v-if="row.quoted_message.from_me == 0"
                                                      >{{ row.quoted_message.message_name}}</b>
                                                      <b v-else>You</b>
                                                    </i>
                                                  </small>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'text'"
                                                  >{{row.quoted_message.message}}</p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'"
                                                  >
                                                    <i class="fa fa-file-image-o"></i> image
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'document'"
                                                  >
                                                    <i class="fa fa-file-o"></i> doc
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'video' "
                                                  >
                                                    <i class="fa fa-file-image-o"></i> video
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'file' "
                                                  >
                                                    <i class="fa fa-file-image-o"></i> file
                                                  </p>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <small
                                        class="text-info"
                                        v-if="row.from_me == 0 && row.is_group == 1"
                                      >
                                        <i>
                                          <b>{{ row.participant_name}}</b>
                                        </i>
                                      </small>
                                      <ul class="attach-list">
                                        <li>
                                          <a target="_blank" :href="row.message_media">
                                            <template v-if="row.message_type!='video'">
                                              <i class="fa fa-file"></i>
                                              {{getExt(row.message)}}
                                            </template>
                                            <template v-else>
                                              <i class="fa fa-film"></i>
                                              {{getExt(row.message_media)}}
                                            </template>
                                          </a>
                                          <small>
                                            <br />
                                            <template
                                              v-if="row.message_type!='video'"
                                            >{{row.message}}</template>
                                            <template v-else>video</template>
                                            {{row.media_size}}
                                          </small>
                                        </li>
                                      </ul>
                                      <span class="chat-time">{{row.timeMinuteHour}}</span>
                                    </div>
                                    <div class="chat-action-btns">
                                      <ul>
                                        <li>
                                          <a
                                            @click="replyMessage(row.id)"
                                            href="javascript:void(0)"
                                            id="a-reply-msg"
                                            class="edit-msg"
                                          >
                                            <i :class="'fa fa-reply reply#' + row.id "></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div class="chat-bubble" v-else-if="row.message_type=='image'">
                                    <div class="chat-content img-content">
                                      <div
                                        class="chat-file-desc"
                                        v-if="typeof row.quoted_message != 'undefined'"
                                      >
                                        <div class="experience-box">
                                          <ul class="experience-list">
                                            <li>
                                              <div class="experience-user">
                                                <div class="before-circle"></div>
                                              </div>
                                              <div
                                                class="experience-content"
                                                style="margin-left:20px;"
                                              >
                                                <div
                                                  style="margin-right:5px;margin-left:5px;"
                                                  class="timeline-content"
                                                >
                                                  <small class="text-info">
                                                    <i>
                                                      <b
                                                        v-if="row.quoted_message.from_me == 0"
                                                      >{{ row.quoted_message.message_name}}</b>

                                                      <b v-else>You</b>
                                                    </i>
                                                  </small>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'text'"
                                                  >{{row.quoted_message.message}}</p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'"
                                                  >
                                                    <i class="fa fa-file-image-o"></i> image
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'video' "
                                                  >
                                                    <i class="fa fa-film"></i> video
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'file' "
                                                  >
                                                    <i class="fa fa-file-image-o"></i> file
                                                  </p>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <small
                                        class="text-info"
                                        v-if="row.from_me == 0 && row.is_group == 1"
                                      >
                                        <i>
                                          <b>{{ row.participant_name}}</b>
                                        </i>
                                      </small>
                                      <div class="chat-img-group clearfix">
                                        <a
                                          class="chat-img-attach"
                                          @click.prevent="openGallery(row.message_media)"
                                        >
                                          <img
                                            width="182"
                                            height="137"
                                            alt
                                            v-lazy="row.message_media"
                                          />
                                          <div class="chat-placeholder">
                                            <div class="chat-file-desc">{{row.media_size }}</div>
                                          </div>
                                        </a>
                                        <p
                                          v-html="messageFilter(row.message)"
                                          v-if="row.message!='' &&  row.message!='-'"
                                          v-linkified
                                        ></p>
                                        <span class="chat-time">{{row.timeMinuteHour}}</span>
                                      </div>
                                    </div>
                                    <div class="chat-action-btns">
                                      <ul>
                                        <li>
                                          <a
                                            @click="replyMessage(row.id)"
                                            href="javascript:void(0)"
                                            id="a-reply-msg"
                                            class="edit-msg"
                                          >
                                            <i :class="'fa fa-reply reply#' + row.id "></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div
                                    v-else-if="row.message_type=='text' || row.message_type=='sticker' || row.message_type=='location'"
                                    class="chat-bubble"
                                  >
                                    <div class="chat-content">
                                      <div
                                        class="chat-file-desc"
                                        v-if="typeof row.quoted_message != 'undefined'"
                                      >
                                        <div class="experience-box">
                                          <ul class="experience-list">
                                            <li>
                                              <div class="experience-user">
                                                <div class="before-circle"></div>
                                              </div>
                                              <div
                                                class="experience-content"
                                                style="margin-left:20px;"
                                              >
                                                <div
                                                  style="margin-right:5px;margin-left:5px;"
                                                  class="timeline-content"
                                                >
                                                  <small class="text-info">
                                                    <i>
                                                      <b
                                                        v-if="row.quoted_message.from_me == 0"
                                                      >{{ row.quoted_message.message_name}}</b>
                                                      <b v-else>You</b>
                                                    </i>
                                                  </small>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'text'"
                                                  >{{row.quoted_message.message}}</p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'"
                                                  >
                                                    <i class="fa fa-file-image-o"></i> image
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'video' "
                                                  >
                                                    <i class="fa fa-film"></i> video
                                                  </p>
                                                  <p
                                                    v-if="row.quoted_message.message_type == 'file' "
                                                  >
                                                    <i class="fa fa-file-image-o"></i> file
                                                  </p>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <small
                                        class="text-info"
                                        v-if="row.from_me == 0 && row.is_group == 1"
                                      >
                                        <i>
                                          <b>{{ row.participant_name}}</b>
                                        </i>
                                      </small>
                                      <img
                                        style="max-width:50px;"
                                        v-lazy="row.message_media"
                                        v-if="row.message_type=='sticker'"
                                      />
                                      <p
                                        v-if="row.message_type=='text'"
                                        v-html="messageFilter(row.message)"
                                        v-linkified
                                      ></p>
                                      <p
                                        v-if="row.message_type=='location'"
                                        v-html="row.message"
                                        v-linkified
                                      ></p>
                                      <span class="chat-time">{{row.timeMinuteHour}}</span>
                                    </div>
                                    <div class="chat-action-btns">
                                      <ul>
                                        <li>
                                          <a
                                            @click="replyMessage(row.id)"
                                            href="javascript:void(0)"
                                            id="a-reply-msg"
                                            class="edit-msg"
                                          >
                                            <i :class="'fa fa-reply reply#' + row.id "></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div v-else class="chat-bubble">
                                    <div class="chat-content">
                                      <p class="text-muted">
                                        <i>Sorry, We do not support displaying {{row.message_type}} message at this time.</i>
                                      </p>
                                      <span class="chat-time">{{row.timeMinuteHour}}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-footer">
                  <div class="message-bar" v-if="activeRoomId!=''">
                    <div class="message-inner">
                      <quick-reply />
                    </div>
                  </div>
                  <!-- <hr /> -->
                  <div class="message-bar" v-if="activeRoomId!=''">
                    <div class="message-inner">
                      <a class="link attach-icon" @click.prevent="emojiToggle()">
                        <img style="width:30px;" src="@/assets/emoji.png" alt />
                      </a>
                      <a
                        id="btnDragFiles"
                        class="link attach-icon"
                        href="#"
                        data-toggle="modal"
                        data-target="#drag_files"
                      >
                        <img src="@/assets/attachment.png" alt />
                      </a>
                      <div class="message-area">
                        <div class="input-group" v-if="!!isReplyTo">
                          <div class="experience-box" style="margin-bottom:10px;">
                            <ul class="experience-list">
                              <li>
                                <div class="experience-user">
                                  <div class="before-circle"></div>
                                </div>
                                <div class="experience-content">
                                  <div class="timeline-content">
                                    <div>
                                      <a
                                        href="javascript:void(0)"
                                        @click.prevent="cancelReplyMessage(true)"
                                        class="text-warning"
                                      >
                                        <i class="fa fa-close"></i>
                                      </a>

                                      <span
                                        class="name"
                                        v-if="isReplyMessage.is_group==1 && isReplyMessage.participant_name!=''"
                                      >{{isReplyMessage.participant_name}}</span>
                                      <span
                                        class="name"
                                        v-else-if="isReplyMessage.is_group==1 && isReplyMessage.participant_number!=''"
                                      >{{isReplyMessage.participant_number}}</span>
                                      <span
                                        class="name"
                                        v-else-if="isReplyMessage.is_group==0 && isReplyMessage.from_me==0"
                                      >{{isReplyMessage.message_name}}</span>
                                      <span class="name" v-else>You</span>
                                    </div>
                                    <span class="time">{{isReplyMessage.message}}</span>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="input-group m-b-30">
                          <div class="input-group-prepend">
                            <div class="dropdown dropdown-action">
                              <a
                                href="#"
                                class="action-icon dropdown-toggle text-info"
                                data-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i class="material-icons">more_vert</i>
                              </a>
                              <div class="dropdown-menu dropdown-menu-right">
                                <span style="margin:5px;">
                                  <b>
                                    <u>Template Message:</u>
                                  </b>
                                </span>
                                <template v-for="temp in templateMessage">
                                  <a
                                    class="dropdown-item"
                                    @click.prevent="addTemplateToMesage(temp)"
                                    :key="temp"
                                  >{{temp}}</a>
                                </template>
                              </div>
                            </div>
                          </div>
                          <div class="input-group-append">
                            <Emoji
                              :open="emojiAttr.open"
                              :width="emojiAttr.width"
                              :height="emojiAttr.height"
                              searchLabel="Search emoji here"
                              @click="selectedEmoji"
                            />
                          </div>
                          <textarea
                            ref="messagebox"
                            class="form-control"
                            v-model="textMessage"
                            :placeholder="'Type message...'"
                            @keydown="inputHandler"
                          ></textarea>
                          <span class="input-group-append">
                            <button
                              @click.prevent="textMessageHandler"
                              class="btn btn-custom"
                              type="button"
                            >
                              <i class="fa fa-send"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Chats View -->

            <!-- Chat Right Sidebar -->
            <right-sidebar></right-sidebar>
            <!-- /Chat Right Sidebar -->
          </div>
          <!-- /Chat Main Wrapper -->
        </div>
        <!-- /Chat Main Row -->
        <!-- Drogfiles Modal -->
        <div id="drag_files" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Drag and drop files to upload [max {{maximumUpload}} files]</h5>
                <button
                  id="btnCloseUploadFiles"
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form id="js-upload-form">
                  <!-- <div
                    v-show="$refs.upload && $refs.upload.dropActive"
                    class="upload-drop-zone"
                    id="drop-zone"
                  >
                    <i class="fa fa-cloud-upload fa-2x"></i>
                    <span class="upload-text">
                      Just drag and
                      drop file here
                    </span>
                  </div>-->
                  <div v-show="files.length==0" class="upload-drop-zone" id="drop-zone">
                    <i class="fa fa-cloud-upload fa-2x"></i>
                    <span class="upload-text">
                      <label :for="name">
                        Just drag and
                        drop file here
                      </label>
                    </span>
                  </div>
                  <h4 v-if="files.length">Uploading</h4>
                  <ul class="upload-list" v-if="files.length">
                    <li v-for="file in files" :key="file.id" class="file-list">
                      <div class="upload-wrap">
                        <div class="file-name">
                          <!-- <i class="fa fa-photo"></i> -->
                          <img style="width:30px;" v-if="file.thumb" :src="file.thumb" />
                          {{file.name}}
                        </div>
                        <div class="file-size">{{formatSizes(file.size)}}</div>
                        <div class="file-close">
                          <span class="text-danger" v-if="file.error">{{file.error}}</span>
                          <span v-else-if="file.success">
                            <i class="text-success fa fa-check-circle"></i>
                          </span>
                          <span v-else-if="file.active">active</span>
                          <span v-else></span>

                          <a
                            href="#"
                            @click.prevent="$refs.upload.remove(file)"
                            class="text-warning"
                          >
                            <i class="fa fa-trash-o"></i>
                          </a>
                        </div>
                      </div>

                      <div
                        class="progress progress-xs progress-striped"
                        v-if="file.active || file.progress !== '0.00'"
                      >
                        <div
                          class="progress-bar bg-success"
                          role="progressbar"
                          :style="{width: file.progress + '%'}"
                        ></div>
                      </div>
                      <div
                        class="upload-process"
                        v-if="file.active || file.progress !== '0.00'"
                      >{{file.progress}}% done</div>
                    </li>
                  </ul>
                </form>
                <!-- Active: {{$refs.upload ? $refs.upload.active : false}}
                <br />
                Uploaded: {{$refs.upload ? $refs.upload.uploaded : true}}-->
                <div class="row" v-if="$refs.upload && $refs.upload.active==true">
                  <div class="col-sm-2">
                    <Skeleton :height="'40px'" :count="1" />
                  </div>
                  <div class="col-sm-2">
                    <Skeleton :height="'40px'" :count="1" />
                  </div>
                  <div class="col-sm-6">
                    <Skeleton :height="'40px'" :count="1" />
                  </div>
                  <div class="col-sm-2">
                    <Skeleton :height="'40px'" :count="1" />
                  </div>
                </div>
                <div class="row" v-show="($refs.upload && $refs.upload.active==false) ">
                  <div class="col-sm-12">
                    <div class="submit-section">
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <file-upload
                            :add-index="true"
                            class="btn btn-outline-secondary"
                            :data="objFilesMessageHandler"
                            :post-action="uploadUrl"
                            :multiple="true"
                            :headers="headers"
                            :drop="true"
                            :drop-directory="true"
                            v-model="files"
                            @input-filter="inputFilter"
                            @input-file="inputFile"
                            ref="upload"
                            :maximum="maximumUpload"
                            :extensions="extensions"
                          >
                            <img src="@/assets/attachment.png" alt />
                          </file-upload>
                          <button
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-if="uploadMessageType==''"
                          >Options</button>
                          <button
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-else
                          >{{uploadMessageType}}</button>
                          <div class="dropdown-menu">
                            <a
                              @click.prevent="updateMessageTypeCurrent(opt)"
                              class="dropdown-item"
                              href="#"
                              v-for="(opt,index) in messageTypeOptionsUpload"
                              :key="index"
                            >
                              <i
                                class="text-success fa fa-check-circle"
                                v-if="uploadMessageType==opt"
                              ></i>
                              {{opt}}
                            </a>
                          </div>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Caption"
                          aria-label="Caption"
                          aria-describedby="basic-addon2"
                          :disabled="uploadMessageType!='image'"
                          v-model="caption"
                          @keydown="inputFileHandler"
                        />

                        <div class="input-group-append">
                          <button
                            @click.prevent="$refs.upload.active = true"
                            class="btn btn-outline-secondary"
                            type="button"
                          >Send</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="alert alert-warning">
                      <ul>
                        <li>Support files: {{extensions}}</li>
                        <li>MaxSize: 10Mb</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- /Add Group Modal -->
        <!-- Add Chat User Modal -->
        <direct />
        <broadcast />
        <filters-form />
        <!-- /Add Chat User Modal -->
        <!-- Share Files Modal -->

        <!-- /Share Files Modal -->
      </div>
    </div>
  </div>
</template>
<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";

import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import FileUpload from "vue-upload-component";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import LightBox from "vue-image-lightbox";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import { Skeleton } from "vue-loading-skeleton";
import InfiniteLoading from "vue-infinite-loading";
import { mapGetters } from "vuex";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes
} from "@/utils/helper";
import { uuid } from "vue-uuid";
import LayoutHeader from "@/components/layouts/Header.vue";
import LeftSidebar from "./LeftSidebar.vue";
import RightSidebar from "./RightSidebar.vue";
import Direct from "./direct.vue";
import Broadcast from "./broadcast.vue";
import FiltersForm from "./components/filters.vue";
import QuickReply from "./components/quickReply.vue";
export default {
  components: {
    FiltersForm,
    QuickReply,
    Broadcast,
    Direct,
    FileUpload,
    Emoji: VueChatEmoji,
    LayoutHeader,
    LeftSidebar,
    RightSidebar,
    InfiniteLoading,
    Skeleton,
    LightBox
  },
  data() {
    return {
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      isNotResolveData: true,
      // headers: {
      //   "X-Auth-Token": "Bearer " + this.getXAuthToken,
      //   "X-Auth-Agent": "Bearer " + this.getXAuthAgent
      // },
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: false,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICoreV2() +
        "/omni/room/send-file",
      // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-filemq",
      // uploadUrl:
      // process.env.VUE_APP_BASE_API +
      // this.APICore() +
      // "/omni/room/only-upload-file",
      // uploadMessageType: "image",
      maximumUpload: 3,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions: "jfif, gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      initScrollTop: 0,
      loadingMessage: false,
      counter: 0,
      isReplyTo: false,
      isReplyMessage: {},
      isSending: false,
      roomDetail: {
        room_title: "",
        provider: "",
        room_photo: "",
        update_datetime: 0,
        room_number: ""
      },
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      textMessageData: [],
      timestamp: Date.now(),
      textMessage: "",
      isSearch: false,
      // roomData: [],
      loading: false,
      currentState: null,
      loadColdChats: false,
      activeClass: "active",
      roomId: "",
      keywords: "",
      hotChatParam: {
        keywords: "",
        room_id: "",
        page: 0,
        perPage: 50,
        rendered: 0,
        totalRecords: 0
      },
      avatarArr: {
        room_title: "",
        room_photo: "@/assets/profiles/avatar-05.jpg"
      },
      chatContent: ""
      // activeId: ""
    };
    //  isactive : true
  },
  watch: {
    agentSession: {
      handler: function(val, oldVal) {
        if (typeof val.license_id == "undefined" || val.license_id == "") {
          this.$fire({
            title: "Error",
            text:
              "We cannot get your agent session, please login as agent for using this feature.",
            type: "error",
            timer: 3000
          }).then(async r => {
            this.$router.push("/index");
          });
        }
      },
      deep: true
    },
    NEW_UNREAD_MESSAGE_ROOM_Data: {
      handler: function(val, oldVal) {
        // console.log("oldVal", oldVal);
        // console.log("newVal", val);
        this.newMessageHandler(val);
      },
      deep: true
    },
    activeRoomId: {
      handler: function(val, oldVal) {
        if (val != "" && val != oldVal) {
          if (oldVal != "") {
            this.getMessageRoomUnsub(oldVal);
          }
          this.getNewUnreadMessageRoom(val);
        }
      },
      deep: true
    },
    hotChatListArr: {
      handler: function(val, oldVal) {
        if (val.length > 0 && val != oldVal) {
          this.buildMediaLightbox();
          this.buildMediaFile();
        }
      },
      deep: true
    }
  },
  mounted() {
    if (
      typeof this.agentSession.license_id == "undefined" ||
      this.agentSession.license_id == ""
    ) {
      console.log("agentsss", this.agentSession);
      this.$fire({
        title: "Error",
        text:
          "We cannot get your agent session, please login as an agent for using this feature.",
        type: "error",
        timer: 3000
      }).then(async r => {
        this.$router.push("/index");
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }

    // Detect when scrolled to bottom.
    const listElm = document.querySelector(".chat-wrap-inner");
    listElm.addEventListener("scroll", e => {
      // console.log("listElm.scrollTop::", listElm.scrollTop);
      // console.log("listElm.clientHeight::", listElm.clientHeight);
      // console.log("listElm.scrollHeight::", listElm.scrollHeight);

      // if (
      //   listElm.scrollHeight - listElm.scrollTop <=
      //   listElm.clientHeight + 50
      // ) {
      //   this.getUsers();
      // }

      // console.log("calc", listElm.scrollHeight - listElm.scrollTop);
      // console.log("calc2", listElm.clientHeight + 50);
      if (listElm.scrollTop === 0) {
        console.log(
          "scrolllex",
          this.hotChatParam.rendered,
          this.hotChatParam.totalRecords
        );
        // if (listElm.scrollTop <= listElm.clientHeight) {
        // if (listElm.scrollTop + listElm.clientHeight === listElm.scrollHeight) {
        // console.log("dipucuk");
        this.infiniteHandler(
          this.currentState,
          this.hotChatParam.rendered,
          this.hotChatParam.totalRecords
        );
        // console.log("this.hotChatParam.rendered", this.hotChatParam.totalData);
        // listElm.scrollTop = listElm.clientHeight;
        // listElm.scrollTop = 4679;
        listElm.scrollTop = 4500;
        // console.log("listElm.scrollTop::this.initScrollTop", listElm.scrollTop);

        // this.initScrollTop = listElm.scrollHeight;
        // console.log(
        //   "listElm.scrollTop::this.initScrollTop",
        //   this.initScrollTop
        // );

        // return;
        // this.scrollToBottom(true);
      } else {
        //stop loadmore
        this.infiniteHandler(this.currentState, 0, 0);
      }
    });

    const chatActionsBtns = document.querySelector(".chat-wrap-inner");
    chatActionsBtns.addEventListener("click", e => {
      var targetName = event.target;
      var splitArr = targetName.className.split(" ");
      if (splitArr.length > 2) {
        var actName = splitArr[2];
        var splitAct = actName.split("#");
        // console.log(targetName);
        // console.log(splitArr);
        // console.log(actName);
        // console.log(splitAct);
        // console.log(splitAct);
        if (splitAct[0] == "reply") {
          // console.log(splitAct[1]);
          this.replyMessage(splitAct[1]);
        }
      }

      // console.log(event.target);
      // console.log(splitArr);
    });
    // this.$el
    //   .querySelector(".chat-action-btns")
    //   .addEventListener("click", e => console.log(event.target));
  },
  updated() {
    // this.scrollToBottom();
  },
  computed: {
    ...mapGetters([
      "hotChatListArr",
      "activeRoomId",
      "textMessageArr",
      "agentSession",
      "activeProvider",
      "NEW_UNREAD_MESSAGE_ROOM_Data",
      "getRoomById",
      "getHotChatListArrById",
      "getHotChatListArrByDate",
      "roomListArr"
    ]),
    groupChatByDate() {
      return this.hotChatListArr.reduce((p, c) => {
        // const date = new Date(c.StartDateTime).toDateString();
        p[c.timeISODate] = p[c.timeISODate] || [];
        p[c.timeISODate].push(c);
        return p;
      }, {});
    },
    groupMessageMedia() {
      // return [];
      return this.$store.state.omniroom.groupMessageMedia;
    },
    groupMessageMediaFile() {
      // return [];
      return this.$store.state.omniroom.groupMessageMediaFile;
    },
    uploadMessageType() {
      return this.$store.state.omniwa.messageTypeCurrent;
    },
    messageTypeOptionsUpload() {
      return this.$store.state.omniwa.messageTypeOptionsUpload;
    },
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken(),
        "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    objFilesMessageHandler() {
      return this.$store.state.omniwa.objFilesMessageHandler;
    }
    // isUploadActive() {
    //   return typeof (this.$refs.upload != "undefined")
    //     ? this.$refs.upload.active
    //     : false;
    // },
    // isUploadCompleted() {
    //   // return this.$refs.upload.uploaded;
    //    return typeof (this.$refs.upload != "undefined")
    //     ? this.$refs.upload.uploaded
    //     : true;
    // }

    // newUUID: function() {
    //   const newID = uuid.v4();
    //   return newID;
    // }
  },
  async created() {
    // this.$refs.messagebox.$el.focus();

    // console.log("agggg", JSON.parse(getAgentSession()));
    this.$root.$on("switchRoom", async roomArr => {
      await this.emojiToggle(false);

      this.isSearch = await false;
      this.keywords = await "";
      // console.log("roomArr:", roomArr);
      // this.roomId = await roomId;
      // this.getHotChatList(roomId);
      this.avatarArr.room_title = await roomArr.room_title;
      // if (roomArr.room_photo != "") {
      this.avatarArr.room_photo = await roomArr.room_photo;
      // }
      this.chatContent = await "";
      await this.getHotChatList(roomArr.room_id);
      // await this.generateMessage(roomArr.room_id);
      this.loadColdChats = await true;

      this.roomDetail = await this.$store.getters.getRoomById(roomArr.room_id);
      await this.cancelReplyMessage();
      await this.scrollToBottom();
      await this.buildMediaLightbox();
      await this.buildMediaFile();
      this.isNotResolve(roomArr.room_id);
    });

    this.$root.$on("openGallery", async message_media => {
      this.openGallery(message_media);
    });
    // console.log("hotChatList", this.hotChatListArr);
  },
  beforeDestroy() {
    this.$root.$off("switchRoom");
    this.$root.$off("openGallery");
    this.$root.$off("pollCheckIsOnline");
    this.$store.dispatch("omniroom/setIsShowDirectChats", false);
    this.$store.dispatch("omniroom/setIsShowBroadcast", false);
  },
  methods: {
    addTemplateToMesage(template) {
      this.textMessage += template;
    },
    async setResolve() {
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          this.$store
            .dispatch("omniroom/setResolve", this.activeRoomId)
            .then(() => {
              this.isNotResolveData = false;
              this.$store.dispatch("omniroom/setActiveRoomId", "");
              setTimeout(function() {
                location.reload();
              }, 3000);
            });
        }
      });
    },
    isNotResolve(roomId) {
      this.$store.dispatch("omniroom/isNotResolve", roomId).then(response => {
        this.isNotResolveData = response;
      });
    },
    updateMessageTypeCurrent(msgType) {
      this.$store.dispatch("omniwa/messageTypeCurrent", msgType);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    },
    async onlyUploadFile() {
      var formData = await new FormData();
      await formData.append("files", this.files[0].file);
      await formData.append("message_type", "image");
      // return this.storeResource(formData);
      // var postData = {};
      // postData = { files: this.files[0].file, message_type: "image" };
      // console.log("postdata", postData);
      await this.$store
        .dispatch("omniwa/onlyUploadFile", formData)
        .then(response => {
          console.log("respp", response);
          return Promise.resolve(response);
        })
        .catch(err => {
          // console.log("errrr", err.response);
          return Promise.reject(err.response.data.msg);
        });
      // return await component.uploadHtml4(this.files[0].file);
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        if (this.activeRoomId == "") {
          return prevent();
        }

        var liContainer = document.getElementById("drag_files");
        var isShowModal = liContainer.classList.contains("show");
        if (isShowModal == false) {
          document.getElementById("btnDragFiles").click(); // Click on the checkbox
        }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.upload.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.upload.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.upload.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          this.$refs.upload.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    // add, update, remove File Event
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // console.log("oldddd", oldFile);
        // console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          var dataArr = {
            recipient_number: this.getWhatsappNumberFromJid(
              this.roomDetail.room_number
            ),
            id: uuid.v4(),
            text: this.caption,
            quoted_id:
              this.isReplyTo == true ? this.isReplyMessage.message_id : "",
            quoted_message:
              this.isReplyTo == true ? this.isReplyMessage.message : "",
            // message_media: messaegMedia,
            message_type: this.uploadMessageType
          };
          this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.$refs.upload.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.upload.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.upload.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => {});
        }
        if (newFile.success && !oldFile.success) {
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response.id) {
          // $.ajax({
          //   type: 'DELETE',
          //   url: '/upload/delete?id=' + oldFile.response.id,
          // })
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    async openGallery(messageUrl) {
      var index = await this.getIndexImage(messageUrl);
      // console.log("indexxx", messageUrl, index);
      // if(index)
      await this.$refs.lightbox.showImage(index);
    },
    buildMediaLightbox() {
      var data = [];
      this.hotChatListArr.forEach((rowArr, index) => {
        var row = {};
        if (rowArr.message_type == "image") {
          row = {
            from_me: rowArr.from_me,
            media_size: rowArr.media_size,
            message_type: rowArr.message_type,
            message_name: rowArr.message_name,
            message_media: rowArr.message_media,
            timeISODatetime: rowArr.timeISODatetime,
            thumb: rowArr.message_media,
            src: rowArr.message_media,
            caption: rowArr.message // Optional
          };
          data.push(row);
        }
      });
      this.$store.dispatch("omniroom/setGroupMessageMedia", data);
      // return data;
    },
    buildMediaFile() {
      var data = [];
      this.hotChatListArr.forEach((rowArr, index) => {
        var row = {};
        if (rowArr.message_type == "document") {
          row = {
            from_me: rowArr.from_me,
            media_size: rowArr.media_size,
            message_type: rowArr.message_type,
            message_name: rowArr.message_name,
            message_media: rowArr.message_media,
            timeISODatetime: rowArr.timeISODatetime,
            thumb: rowArr.message_media,
            src: rowArr.message_media,
            caption: rowArr.message // Optional
          };
          data.push(row);
        }
      });
      this.$store.dispatch("omniroom/setGroupMessageMediaFile", data);
      // return data;
    },
    getIndexImage(messageUrl) {
      var index = this.groupMessageMedia
        .map(x => {
          return x.src;
        })
        .indexOf(messageUrl);
      return index;
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
    cancelReplyMessage(force = false) {
      // console.log("this.isReplyMessage", this.isReplyMessage);
      // console.log("this.roomDetail.room_number", this.roomDetail);

      if (force == true) {
        this.isReplyTo = false;
        return;
      }

      if (
        this.isReplyMessage != null &&
        typeof this.isReplyMessage.message_number != "undefined"
      ) {
        if (this.roomDetail.room_number == "") {
          this.isReplyTo = false;
        }
        if (this.isReplyMessage.message_number != this.roomDetail.room_number) {
          this.isReplyTo = false;
        }
      }
    },
    replyMessage(msgListId) {
      // alert("xxx");
      if (typeof msgListId != "undefined" && msgListId != "") {
        this.isReplyTo = true;
        this.isReplyMessage = this.$store.getters.getHotChatListArrById(
          msgListId
        );
        // console.log("msgArr", this.isReplyMessage);
      }
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    getAgentSession() {
      return getAgentSession();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.textMessage += args.emoji;
      // console.log(args); /* return {...}*/
    },
    async getMessageRoomUnsub(roomId) {
      console.log("before if::", "getMessageRoomUnsub");

      if (roomId != "") {
        console.log("action::", "getNewUnreadMessageRoom");
        let paramArr = await {
          room_id: roomId,
          license_id: this.agentSession.license_id,
          id: this.agentSession.id
        };
        await this.$store.dispatch(
          "pusher/NEW_UNREAD_MESSAGE_ROOM_UNSUB",
          paramArr
        );
      }
    },
    async getNewUnreadMessageRoom(roomId) {
      console.log("before if::", "getNewUnreadMessageRoom");

      if (roomId != "") {
        console.log("action::", "getNewUnreadMessageRoom");
        let paramArr = await {
          room_id: roomId,
          license_id: this.agentSession.license_id,
          id: this.agentSession.id
        };
        console.log(paramArr);
        await this.$store.dispatch("pusher/NEW_UNREAD_MESSAGE_ROOM", paramArr);
      }
    },
    async newMessageHandler(messageArr) {
      if (typeof messageArr != "undefined" && messageArr.length > 0) {
        await messageArr.forEach((row, index) => {
          var index = this.hotChatListArr
            .map(x => {
              return x.id;
            })
            .indexOf(row.id);
          if (index >= 0) {
            this.hotChatListArr.splice(index, 1);
          }
          // console.log(("row", row));
          this.hotChatListArr.push(row);
        });
        // await console.log("akhir", this.hotChatListArr);
        this.chatContent = await "";
        await this.generateMessage(this.activeRoomId);
        await this.buildMediaLightbox();
        await this.buildMediaFile();
        await this.scrollToBottom();
      }
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    inputHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.textMessageHandler();
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.upload.active = true;
      }
    },
    formatDateForMessage(dateIso, type) {
      return formatDateForMessage(dateIso, type);
    },
    async filesMessageHandler() {
      this.$refs.upload.active = await true;

      if (this.files.length) {
        this.isSending = await true;
        await this.emojiToggle(false);
        this.textMessage = await this.remove_tags(this.textMessage);
        var agentName =
          (await this.agentSession.is_owner) == 1
            ? ""
            : "\n~" + this.agentSession.first_name;

        this.files.forEach(async (row, index) => {
          // var messaegMedia = await row.response.data.message_media;

          if (this.uploadMessageType == "document") {
            this.textMessage = await "";
            this.isReplyTo = await false;
          }
          if (index > 0 && this.uploadMessageType == "image") {
            this.textMessage = await "";
            this.isReplyTo = await false;
          }

          var dataArr = await {
            recipient_number: this.getWhatsappNumberFromJid(
              this.roomDetail.room_number
            ),
            id: uuid.v4(),
            text: this.textMessage + agentName,
            quoted_id:
              this.isReplyTo == true ? this.isReplyMessage.message_id : "",
            quoted_message:
              this.isReplyTo == true ? this.isReplyMessage.message : "",
            // message_media: messaegMedia,
            message_type: this.uploadMessageType
          };

          var formData = await new FormData();
          await formData.append("file", row.file);
          await formData.append("message_type", this.uploadMessageType);
          await formData.append("id", dataArr.id);
          await formData.append("text", dataArr.text);
          await formData.append("recipient_number", dataArr.recipient_number);
          await formData.append("quoted_id", dataArr.quoted_id);
          await formData.append("quoted_message", dataArr.quoted_message);

          console.log("dtaArr", formData);
          // this.textMessage = await "";
          // await this.$store.dispatch("omniwa/sendFilepath", formData);
          await this.$store.dispatch("omniwa/sendFile", formData);
        });

        await this.cancelReplyMessage(true);
        this.isSending = await false;
        await this.$refs.upload.clear();
        await document.getElementById("btnCloseUploadFiles").click(); // Click on the checkbox
        await this.$fire({
          title: "Success",
          text: "Message is sending, please wait...",
          type: "success",
          timer: 2000
        });
      }
    },
    async textMessageHandler() {
      if (this.textMessage != "") {
        this.isSending = await true;
        this.emojiToggle(false);
        this.textMessage = await this.remove_tags(this.textMessage);
        // this.textMessage = await this.textMessage.replace(/\r?\n/g, "<br />");
        // this.textMessage = JSON.stringify(this.textMessage);
        var agentName =
          (await this.agentSession.is_owner) == 1
            ? ""
            : "\n~" + this.agentSession.first_name;

        var dataArr = await {
          recipient_number: this.getWhatsappNumberFromJid(
            this.roomDetail.room_number
          ),
          id: uuid.v4(),
          text: this.textMessage + agentName,
          quoted_id:
            this.isReplyTo == true ? this.isReplyMessage.message_id : "",
          quoted_message:
            this.isReplyTo == true ? this.isReplyMessage.message : ""
        };
        // console.log("dtaArr", dataArr);
        this.textMessage = await "";
        // this.$refs.messagebox.focus();
        await this.cancelReplyMessage(true);
        await this.$store.dispatch("omniwa/sendText", dataArr).catch(() => {
          this.removeNewRoomAfterSend();
          return false;
        });
        this.isSending = await false;
        this.removeNewRoomAfterSend();
      }
    },

    async changeRoomListArr(data) {
      // console.log("changeHotChatListArr::", data);
      var newArr = this.getUniqueListBy(data, "id");
      // this.$store.dispatch("omniroom/setHotChatListArr", data);
      this.$store.dispatch("omniroom/setRoomListArr", newArr);
    },
    async removeNewRoomAfterSend() {
      if (this.activeRoomId == "new-room") {
        //refresh page
        location.reload();
        // this.$store.dispatch("pusher/UpdateRefreshRoomData", true);

        return false;
      }

      // await this.roomListArr.unshift(dataArr);
    },
    async searchHandler() {
      if (this.activeRoomId != "") {
        this.chatContent = await "";
        await this.getHotChatList(this.activeRoomId);
        this.loading = await false;
      }
    },
    formatDate(dateIso) {
      return formatDate(dateIso);
    },
    async changeHotChatListArr(data) {
      // console.log("changeHotChatListArr::", data);
      var newArr = await this.getUniqueListBy(data, "id");

      // console.log("builllll", buildArr);
      // this.$store.dispatch("omniroom/setHotChatListArr", data);
      await this.$store.dispatch("omniroom/setHotChatListArr", newArr);
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },

    async infiniteHandler($state, numLoaded, totalData, init = false) {
      // console.log("this.activeRoomId::", this.activeRoomId);
      if (init == true) {
        await this.getColdChatList(this.activeRoomId);
      }
      console.log("numLoaded:", numLoaded, totalData);

      // if (numLoaded <= totalData && totalData > 0 && numLoaded > 0) {
      if (numLoaded < totalData && totalData > 0 && numLoaded > 0) {
        if (this.activeRoomId != "") {
          await $state.loaded();
          // this.loading = await true; //dimatikan
          // await $state.loaded();
          if (init == false) {
            await this.getColdChatList(this.activeRoomId);
          }
        }
        // console.log("loaded", numLoaded, totalData);
      } else {
        // console.log("complete", numLoaded, totalData);
        // console.log(
        //   "complete",
        //   this.hotChatParam.totalRecords,
        //   this.hotChatParam.rendered
        // );

        await $state.complete();
        if (numLoaded >= totalData && numLoaded > 0) {
          const listElm = document.querySelector(".chat-wrap-inner");
          listElm.scrollTop = 1;
        }

        if (numLoaded == totalData && totalData > 0) {
          this.chatContent = await "";
          await this.generateMessage(this.activeRoomId);
        }
        // this.loading = await false;

        // console.log("complete", numLoaded, totalData);
      }
      this.currentState = await $state;
    },
    async generateMessage(roomId) {
      this.loading = await true;

      var checkDate = "";
      this.loading = await false;
    },
    lazyHandler(component) {
      console.log("this component is showing");
    },
    async getHotChatList(roomId) {
      this.loading = await true;
      this.hotChatParam.totalRecords = await 0;

      this.hotChatParam.room_id = await roomId;
      this.hotChatParam.keywords = await this.keywords;
      // await this.infiniteHandler(this.currentState, 1, 4);
      await this.$store
        .dispatch("omniroom/getHotChatList", this.hotChatParam) // sesuai kan dengan method di API
        .then(response => {
          this.changeHotChatListArr(response);
          this.hotChatParam.totalRecords = response.length;

          // if (response.totalRecords > 0) {
          //   console.log("response.totalRecords ::", response.totalRecords);
          // }
        })
        .catch(error => {
          this.loading = false;
          console.log("error", error);
        });
      this.hotChatParam.page = await 0;
      this.hotChatParam.rendered = await 0;
      // this.hotChatParam.totalRecords = await 0;
      await this.infiniteHandler(
        this.currentState,
        1,
        this.hotChatParam.totalRecords,
        true
      );
      this.loading = await false;
      // console.log(
      //   "this.hotChatParam.totalRecords::",
      //   this.hotChatParam.totalRecords
      // );
      // await this.scrollIntoView();

      // await this.getColdChatList(roomId);
    },

    // scrollToBottom() {
    scrollToBottom() {
      const container = this.$el.querySelector(".chat-wrap-inner");
      this.$nextTick(() => {
        // DOM updated
        // if (setForce == false) {
        container.scrollTop = container.scrollHeight;
        // this.initScrollTop = container.scrollTop;
        // console.log("this.initScrollTop", this.initScrollTop);
        // } else {
        //   container.scrollTop = 300;
        // }
        // container.scrollTop = 100;
        // console.log("container.scrollTop:::", container.scrollTop);
      });
    },

    async getColdChatList(roomId) {
      // this.loading = await true;
      // alert("cold");
      // console.log("coldChat")
      this.hotChatParam.room_id = await roomId;
      this.hotChatParam.keywords = await this.keywords;
      await this.$store
        .dispatch("omniroom/getColdChatList", this.hotChatParam) // sesuai kan dengan method di API
        .then(response => {
          // const { data } = response;
          if (response.data.length > 0) {
            this.hotChatListArr.unshift(...response.data.reverse());
            this.changeHotChatListArr(this.hotChatListArr);
            this.hotChatParam.rendered =
              this.hotChatParam.page + response.recordsFiltered;
            this.hotChatParam.page += response.recordsFiltered;
            if (response.totalRecords > 0) {
              this.hotChatParam.totalRecords = response.totalRecords;
            }

            // this.infiniteHandler(
            //   this.currentState,
            //   this.hotChatParam.rendered,
            //   response.totalRecords
            // );

            this.infiniteHandler(this.currentState, 0, 0);
            this.loading = false;
          }

          // console.log("coldResp", response.data);
          // console.log("coldRespUnshift", this.hotChatListArr);

          // console.log("this.hotChatParam.page", this.hotChatParam.page);
          // console.log("this.hotChatParam.rendered", this.hotChatParam.rendered);
          // console.log("totalRecords::", this.hotChatParam.totalRecords);
        })
        .catch(error => {
          this.loading = false;

          console.log("error", error);
        });
      this.chatContent = await "";
      await this.generateMessage(this.activeRoomId);
    }
  },
  name: "omni"
};
</script>



// WEBPACK FOOTER //
// src/views/omni/index.vue